import React, { useLayoutEffect, useMemo, useState } from "react"
import { ClipboardList } from "lucide-react"
import CustomAccordion from "./custom-accordion"
import { sampleItem } from "@/routes/(app)/_layout/inventory/$itemId/-data/fixtures"

export default function TimelineGroupItem({ group, last, isRecent }: { group: typeof sampleItem.timeline[number]; last: boolean; isRecent: boolean }) {
  const [lineHeight, setLineHeight] = useState<number | null>(null)
  const ref = useMemo(() => ({ current: null as unknown as HTMLDivElement }), []) as { current: HTMLDivElement | null }
  useLayoutEffect(() => {
    if (ref.current && !last) {
      setLineHeight(Math.max(0, ref.current.offsetHeight - 16))
    }
  }, [last, group])

  return (
    <div className="space-y-2">
      <CustomAccordion title={group.when} defaultOpen>
        <div className="flex items-start gap-3 relative" ref={ref as any}>
          <div className="relative flex flex-col items-center">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-lg bg-blue-50 z-10">
              <ClipboardList className="w-3.5 h-3.5 text-blue-600" />
            </span>
            {!last && lineHeight !== null && lineHeight > 0 && (
              <span className="absolute left-1/2 top-6 -translate-x-1/2 w-px bg-blue-100" style={{ height: `${lineHeight}px` }} />
            )}
          </div>
          <div className="flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <div className="font-medium">{group.label}</div>
              {group.badge && (
                <span className="text-[11px] rounded-md bg-gray-100 text-gray-700 px-2 py-[2px]">{group.badge}</span>
              )}
              <span className="text-[11px] text-muted-foreground">{isRecent ? "1 day ago" : ""}</span>
            </div>
            <div className="mt-2 space-y-2">
              {group.cards.map((c, idx) => (
                <div key={idx} className="rounded-md border border-gray-200 px-3 py-2 w-fit">
                  <div className="font-medium text-sm">{c.title}</div>
                  <div className="text-xs text-muted-foreground mt-1">{c.quantityText}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CustomAccordion>
    </div>
  )
}

